{
  "optional": "Optional",
  "geoLatitude": "Geo Latitude",
  "geoLongitude": "Geo Longitude",
  "latitude": "Latitude",
  "enterLatitude": "Enter Latitude",
  "longitude": "Longitude",
  "enterLongitude": "Enter Longitude",
  "weCollectLatitudeLongitudeEvery": "We collect the latitude and longitude for every building so we know precisely where each building is on the campus.",
  "howCopyLatitudeLongitude": "How to copy the latitude and longitude",
  "togglePasswordVisibility": "toggle password visibility",
  "title": "Title",
  "country": "Country",
  "unrealLocationX": "Unreal Location X",
  "unrealLocationY": "Unreal Location Y",
  "buildingAreaSqFt": "Building Area in Sq Ft",
  "campusAttributeNameDirectory": "Campus Attribute Name in Directory",
  "nameCampusActiveDirectoryOther": "This is the name of the campus in your Active Directory or other directory service. We collect this so that we can automatically correlate each user to the right campus based on the info in your Active Directory.",
  "city": "City",
  "directoryAttribute": "Directory Attribute",
  "identityProviderIssuer": "Identity Provider Issuer",
  "edpEntityIdServiceUse": "The EdP Entity ID for the service you use.",
  "metadataUrl": "Metadata Url",
  "notes": "Notes",
  "notesPlaceholder": "notes...",
  "enterPhoneNumber": "Enter Phone Number",
  "publicCertificate": "Public Certificate",
  "copyPasteEntireX509": "Copy and paste your entire x.509 Certificate here.",
  "saml20EndpointHttp": "SAML 2.0 Endpoint (HTTP)",
  "saml20Endpoint": "SAML 2.0 Endpoint",
  "whereGoWhenTryLogin": "This is where you go when you try to login.",
  "ofStaff": "# of Staff",
  "ofStudents": "# of Students",
  "tagMeaning": "Tag Meaning",
  "tagMeaningPlaceholder": "a tag meaning...",
  "totalPeopleCapacity": "Total People Capacity",
  "zipCode": "Zip Code",
  "completed": "Completed",
  "notCompleted": "Not Completed",
  "other": "Other",
  "addPoc": "Add POC",
  "invitationLinkSentPersonsEmail": "An invitation link will be sent to this person’s email",
  "externalPoliceDept": "External Police Dept",
  "headOfIt": "Head Of IT",
  "headOfSecurity": "Head Of Security",
  "onsiteIt": "Onsite IT",
  "onsiteSecurity": "Onsite Security",
  "principal": "Principal",
  "superintendent": "Superintendent",
  "state": "State",
  "campusMultiple": "Campus(es)",
  "dr": "Dr",
  "mr": "Mr",
  "miss": "Miss",
  "mrs": "Mrs",
  "domain": "Domain",
  "domainHelper": "Enter the domain without @",
  "domainInvalid": "Enter a valid domain — e.g. company.com",
  "domainAlreadyAdded": "This domain is already on the list.",
  "emailRepeated": "It looks like the email address you entered is repeated",
  "newPassword": "New Password",
  "enterNewPassword": "Enter new password",
  "zipCodeMinLength": "Zip code must be at least 5 characters",
  "zipCodeInvalid": "Use letters and numbers, with one space or hyphen between parts",
  "fieldRequired": "{{label}} is required",
  "thisFieldRequired": "This field is required",
  "fieldTooShort": "{{label}} is too short",
  "fieldTooLong": "{{label}} is too long",
  "fieldInvalid": "Please enter a valid {{label}}",
  "valueInvalid": "Please enter a valid value",
  "phoneDigits": "Phone number must have {{count}} digits",
  "invalidImageFile": "Invalid image file.",
  "clickToUpload": "Click to upload",
  "orDragAndDrop": "or drag and drop",
  "secureCode": "Secure Code",
  "campusNumber": "Campus Number",
  "imageTooLarge": "Image dimensions must not exceed {{width}}×{{height}} pixels.",
  "resetSearch": "Reset search",
  "emailInvalid": "It looks like the email address you entered is invalid",
  "countryCode": "Country code",
  "changeImage": "Change image",
  "coordinateFormatLat": "Enter a latitude like 30.2080 or 30°12'29.1\"N.",
  "coordinateFormatLng": "Enter a longitude like -97.7441 or 97°44'39.0\"W.",
  "coordinateMissingDirectionLat": "Add N or S (or a minus sign).",
  "coordinateMissingDirectionLng": "Add E or W (or a minus sign).",
  "coordinateDirectionLat": "Latitude ends with N or S.",
  "coordinateDirectionLng": "Longitude ends with E or W.",
  "coordinateMinutes": "Minutes and seconds must be less than 60.",
  "coordinateRangeLat": "Latitude must be between -90 and 90.",
  "coordinateRangeLng": "Longitude must be between -180 and 180.",
  "select": "Select"
}
